// extracted by mini-css-extract-plugin
export default {"title":"_5mmkK6G","number":"W-MwqiP"};